/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import Stack from "../../ui/Stack";
import { setSelectedCategory } from "../../../store/slices/productsSlice";
import ProductsCategoryItemSkeleton from "../../skeleton/ProductsCategoryItemSkeleton";
import ProductsCategoryItem from "./ProductsCategoryItem";

const SkeletonsStack = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const CategoriesStack = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const ProductsCategoriesList = React.memo(({ isLoading, categories }) => {
  const dispatch = useDispatch();

  if (isLoading) {
    return (
      <SkeletonsStack $gap="0.5rem">
        <ProductsCategoryItemSkeleton />
      </SkeletonsStack>
    );
  }

  return (
    <CategoriesStack $gap="0.5rem">
      {categories.map((category, key) =>
        <ProductsCategoryItem key={key} category={category} handleCategorySelect={() => dispatch(setSelectedCategory(category))}/>
      )}
    </CategoriesStack>
  );
});

export default ProductsCategoriesList;